export const checkConnectivity = async (): Promise<boolean> => {
  if (!navigator.onLine) {
    return false;
  }
  
  // Actually ping the backend to verify connectivity
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);
    
    const response = await fetch('/health', {
      method: 'HEAD',
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    return response.ok;
  } catch {
    return false;
  }
};
